import * as React from 'react';

export interface PoliticalCommitteeIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * PoliticalCommitteeIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Political Committee / PAC. Green ballot box with ballot slip dropping through the slot.
 */
const PoliticalCommitteeIcon: React.FunctionComponent<PoliticalCommitteeIconProps> = ({
  className,
  size = 40,
  title = 'Political Committee / PAC',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="8" y="20" width="32" height="22" rx="1" fill="#3B6D11"/>
      <rect x="7" y="18" width="34" height="3" rx="0.5" fill="#27500A"/>
      <rect x="20" y="19" width="8" height="1" fill="#0f2a06"/>
      <rect x="14" y="26" width="20" height="12" fill="#FFFFFF"/>
      <line x1="17" y1="29" x2="31" y2="29" stroke="#3B6D11" strokeWidth="0.8"/>
      <line x1="17" y1="32" x2="27" y2="32" stroke="#3B6D11" strokeWidth="0.8"/>
      <line x1="17" y1="35" x2="31" y2="35" stroke="#3B6D11" strokeWidth="0.8"/>
      <rect x="18" y="6" width="12" height="11" fill="#FFFFFF" stroke="#27500A" strokeWidth="0.8"/>
      <path d="M21 11 L23 13 L27 9" stroke="#A32D2D" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default PoliticalCommitteeIcon;
